import { createContext, useContext } from "react"
import { fetchEngDiagAudio } from "../services/eng-diag.service"

/** Fetches the bytes of one clip by its audio_metadata id. */
export type EngAudioFetcher = (audioId: string, signal?: AbortSignal) => Promise<Blob>

/**
 * Where a question's audio comes from.
 *
 * The question view and its rich content are shared by the diagnostics player and the Skill
 * Builder player, but the two read different tables: a clip is scoped to the student through
 * the session it was delivered in, and a Skill Builder's sessions are not diagnostics sessions.
 * The endpoints enforce that, so the player has to say which one it is.
 *
 * Defaults to diagnostics, which is what every existing caller already did.
 */
export const EngAudioFetcherContext = createContext<EngAudioFetcher>(fetchEngDiagAudio)

export function useEngAudioFetcher(): EngAudioFetcher {
  return useContext(EngAudioFetcherContext)
}
